import { Injectable } from '@angular/core';
import { QueryEntity } from '@datorama/akita';
import { map } from 'rxjs/operators';
import { CampaignV2OffersState, CampaignV2OffersStore } from './campaign-v2-offers.store';

@Injectable({ providedIn: 'root' })
export class CampaignV2OffersQuery extends QueryEntity<CampaignV2OffersState> {
  constructor(protected store: CampaignV2OffersStore) {
    super(store);
  }

  selectAllCampaignOffers() {
    return this.selectAll().pipe(
      map((campaignOffers) => {
        return campaignOffers;
      })
    );
  }
}
